import React, {useContext} from "react";
import {Context} from "context";

import styles from "./Tabs.module.scss";

export default function Tabs(props) {
    const context = useContext(Context);

    let myMaps = 0;

    context.folderStructure.forEach((folder) => {
        folder.codeNames.forEach((map) => {
            if(map.favourited || map.swModified) myMaps++
        })
    });
    
    return (
        <div className={`bgTertiary ${styles.tabs}`}>
            <button
                className={`bgTertiary txtTertiary highlightSecondary ${props.tab === 0 ? styles.active : null}`}
                onClick={props.setTab.bind(this, 0)}
                data-hint={context.text.hints.allMaps}
            >
                All Maps
            </button>
            <button
                className={`bgTertiary txtTertiary highlightSecondary ${props.tab === 1 ? styles.active : null}`}
                onClick={props.setTab.bind(this, 1)}
                data-hint={context.text.hints.myMaps}
            >
                My Maps ({myMaps})
            </button>
        </div>
    )
}